import React, { useState } from "react";
import { useParams } from "react-router-dom";
import ActionBar from "../../components/actionBar/ActionBar";
import { data } from "../../../data/data";
import PropertyHandler from "../../components/propertyHandler/PropertyHandler";

const PropertyByDevelopers = () => {
  const path = useParams().developerName;
  let properties = [];
  if (path) {
    properties = data.filter((el) => el.developer?.toLowerCase() === path);
  }
  // console.log(properties.length);

  const [sort, setSort] = useState("name");
  const [listView, setListView] = useState(false);
  const [pageSize, setPageSize] = useState(24);
  return (
    <div className="properties">
      <div className="properties--container">
        <h2> {path.split("-").join(" ")}</h2>
        <ActionBar
          listView={listView}
          setSort={setSort}
          setListView={setListView}
          setPageSize={setPageSize}
        />
        <PropertyHandler
          view={listView}
          sort={sort}
          properties={properties}
          pageSize={pageSize}
        />
      </div>
    </div>
  );
};

export default PropertyByDevelopers;
